export default __webpack_public_path__ + "static/media/dex.8887ccba.png";